import { useEffect, useRef, useState } from "react";
import { Form, Formik } from "formik";
import { postApi, putApi } from "../../services/api/globalApi";
import {
  errorMessage,
  successMessage,
  warningMessage,
} from "../../utils/toastify-message/ToastifyMessage";
import Button from "../../components/common/button/Button";
import AdminFormLayout, { FormSection } from "../../components/common/form-layout/AdminFormLayout";
import Input from "../../components/common/inputs/Input";
import FormikDateOnlyInput from "../../components/common/inputs/FormikDateOnlyInput";
import Select from "../../components/common/inputs/Select";
import { useLocation, useNavigate } from "react-router";
import CurrencyInput from "../../components/common/inputs/CurrencyInput";
import { courseValidation } from "../../utils/validation/course/courseValidation";
import TextArea from "../../components/common/inputs/TextArea";
import Editor from "../../components/common/ck-editor/CkEditor";
import ImagesModal from "../../components/common/modals/imgaes-modal/ImagesModal";
import UserModal from "../../components/common/modals/user-modal/UserModal";
import { PiXFill } from "react-icons/pi";
import { publicImageProps } from "../../services/config";
import CourseFeatures from "./sub-components/course-features/CourseFeatures";
import CourseSection from "./sub-components/course-section/CourseSection";
import CourseQuestions from "./sub-components/course-questions/CourseQuestions";
import LearningOutcomes from "./sub-components/learning-outcomes/LearningOutcomes";
import InstructorInfo from "./sub-components/instructor-info/InstructorInfo";
import { utilsState } from "../../sotre/redux/features/utilsSlice";
import { useSelector } from "react-redux";
import SupportPlatforms from "./sub-components/support/Support";

export default function Course() {
  const location = useLocation();
  const navigate = useNavigate();
  const { utils } = useSelector(utilsState);

  const [description, setDescription] = useState("");
  const [targetAudience, setTargetAudience] = useState("");
  const [freeShipingEndDate, setfreeShipingEndDate] = useState("");
  const [sections, setSections] = useState([]);
  const [courseQuestions, setCourseQuestions] = useState([]);
  const [support, setSupport] = useState([]);
  const [learningOutcomes, setLearningOutcomes] = useState([]);
  const [instructorInfo, setInstructorInfo] = useState({});
  const [courseFeatures, setCourseFeatures] = useState({});

  const saving = useRef(false);
  const formHandler = async (values, { resetForm }) => {
    if (saving.current) return;
    if (location.pathname === "/edit-course" && !location.state?._id) {
      errorMessage("دوره را دوباره از فهرست دوره‌ها برای ویرایش انتخاب کنید.");
      return;
    }
    const body = {
      ...values,
      price: Number(values.price),
      discount: Number(values.discount),
      image: image || "",
      discountType,
      description,
      targetAudience,
      sections,
      courseQuestions,
      learningOutcomes,
      instructor,
      instructorInfo,
      courseFeatures,
      support
    };
    if (
      discountType !== "percent" ||
      (discountType == "percent" && body.discount <= 100)
    ) {
      try {
        saving.current = true;
        if (location?.state?._id) {
          const response = await putApi({
            path: `admin/courses/${location?.state?._id}`,
            body: JSON.stringify(body),
          });
          console.log(response);
          successMessage("دوره با موفقیت ویرایش شد");
        } else {
          const response = await postApi({
            path: "admin/courses",
            body: JSON.stringify(body),
          });
          console.log(response);
          successMessage("دوره با موفقیت اضافه شد");
        }
        resetForm();
        reset();
        navigate("/course-list");
      } catch (error) {
        console.error(error);
        errorMessage(error?.response?.data?.errors?.[0]?.message || "ذخیره دوره انجام نشد.");
      } finally {
        saving.current = false;
      }
    } else {
      warningMessage("درصد تخفیف نمیتواند بیشتر از 100 باشد");
    }
  };

  const [image, setImage] = useState("");
  const [discountType, setDiscountType] = useState(
    location.state?.discountType || "price"
  );
  useEffect(() => {
    if (location.state) {
      setDescription(location.state.description || "");
      setTargetAudience(location.state.targetAudience || "");
      if (location?.state?.image) {
        setImage(location?.state?.image || "");
      }
      if (location?.state?.instructor) {
        setUser(location?.state?.instructor?.name || "");
        setInstructor(location?.state?.instructor?._id || "");
      }
      if (location?.state?.sections?.length) {
        setSections(location?.state?.sections || "");
      }
      if (location?.state?.courseQuestions?.length) {
        setCourseQuestions(location?.state?.courseQuestions || "");
      }
      if (location?.state?.support?.length) {
        setSupport(location?.state?.support || "");
      }
      if (location?.state?.learningOutcomes?.length) {
        setLearningOutcomes(location?.state?.learningOutcomes || "");
      }
      if (location?.state?.instructorInfo) {
        setInstructorInfo(location?.state?.instructorInfo || "");
      }
      if (location?.state?.courseFeatures) {
        setCourseFeatures(location?.state?.courseFeatures || "");
      }
    }
  }, [location.state]);

  const sectionsRef = useRef();

  const questionRef = useRef();
  const priceRef = useRef();
  const discountRef = useRef();
  const learningRef = useRef();
  const instructorRef = useRef();
  const featuresRef = useRef();
  const supportRef = useRef();
  const imagesModal = useRef();

  const handleImages = (data) => {
    setImage(data.name);
  };

  useEffect(() => {
    if (location.pathname == "/add-course") {
      reset();
    }
  }, [location.pathname]);

  const reset = () => {
    priceRef.current.afterSubmit();
    discountRef.current.afterSubmit();
    sectionsRef.current.afterSubmit();
  };
  const copyImagesUrlModal = useRef();

  const userModalRef = useRef();
  const [user, setUser] = useState(null);
  const [instructor, setInstructor] = useState(null);
  const handleUser = (data) => {
    setUser(data.name);
    setInstructor(data._id);
    successMessage(`کاربر ${data?.name} انتخاب شد`);
  };

  const deleteUser = () => {
    setUser("");
    setInstructor("");
  };

  return (
    <AdminFormLayout title={location.state ? "ویرایش دوره" : "افزودن دوره"} description="اطلاعات دوره، قیمت‌گذاری، مدرس و محتوای آموزشی را در بخش‌های زیر مدیریت کنید.">
      <div className="mt-6">
        <Formik
          enableReinitialize
          initialValues={{
            name: location?.state?.name || "",
            shortDescription: location?.state?.shortDescription || "",
            status: location?.state?.status || "active",
            vendorType: location?.state?.vendorType,
            freePack: location?.state?.freePack || false,
            freeShipingEndDate: location?.state?.freeShipingEndDate
              ? location?.state?.freeShipingEndDate.split("T")[0]
              : "",
            price: location?.state?.price || "",
            targetAudience: location?.state?.targetAudience || "",
            discount:
              location?.state?.discountType === "price"
                ? location?.state?.discountPrice
                : location?.state?.discountPercent || "",
          }}
          validationSchema={courseValidation}
          onSubmit={formHandler}
        >
          {(formik) => (
            <Form>
              <FormSection title="مشخصات اصلی" description="نامی روشن و قابل جستجو برای دوره انتخاب کنید.">
              <div className="grid gap-6 mb-4 md:grid-cols-2">
                <Input name="name" placeholder="نام دوره را وارد کنید" label="نام دوره" type="text" />
              </div>
              </FormSection>
              <FormSection title="قیمت‌گذاری و تخفیف" description="قیمت‌ها را مطابق واحد پول فروشگاه وارد کنید. تخفیف درصدی نباید بیشتر از ۱۰۰ باشد.">
              <div className="grid gap-6 mb-4 md:grid-cols-2">
                <div>
                  <label
                    htmlFor="price"
                    className="backdrop-blur block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    قیمت
                  </label>
                  <CurrencyInput
                    placeholder="قیمت "
                    name="price"
                    id="price"
                    ref={priceRef}
                    inputValue={formik.values.price}
                    onChange={(e) => formik.setFieldValue("price", e)}
                  />
                  {formik.errors.price && formik.touched.price ? (
                    <p className="text-sm my-4 text-red-500">
                      {formik.errors.price}
                    </p>
                  ) : null}
                </div>
                <div>
                  <label htmlFor="discountType" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                    نوع تخفیف
                  </label>
                  <select
                    id="discountType"
                    value={discountType}
                    onChange={(e) => setDiscountType(e.target.value)}
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  >
                    <option value={"percent"}>درصد</option>
                    <option value={"price"}>قیمت</option>
                  </select>
                </div>
                <div>
                  <label
                    htmlFor="discount"
                    className="backdrop-blur block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    تخفیف
                  </label>
                  <CurrencyInput
                    placeholder="تخفیف"
                    ref={discountRef}
                    name="discount"
                    inputValue={formik.values["discount"]}
                    onChange={(e) => formik.setFieldValue("discount", e)}
                  />
                  {formik.errors.discount && formik.touched.discount ? (
                    <p className="text-sm my-4 text-red-500">
                      {formik.errors.discount}
                    </p>
                  ) : null}
                </div>

              </div>
              </FormSection>
              <FormSection title="انتشار، مدرس و تصویر" description="وضعیت نمایش، مدرس و تصویر اصلی دوره را مشخص کنید.">
              <div className="grid gap-6 mb-4 md:grid-cols-2">
                <Select name="status" placeholder="وضعیت" label="وضعیت">
                  <option value={"active"}>فعال</option>
                  <option value={"pending"}>در حال بررسی</option>
                  <option value={"inactive"}>غیر فعال</option>
                </Select>

                <Select
                  name="freePack"
                  value={formik.values["freePack"] ? "true" : "false"}
                  onChange={(e) => {
                    formik.setFieldValue("freePack", e.target.value === "true");
                  }}
                  placeholder="دارای پک؟"
                  label="دارای پک؟"
                >
                  <option value="true">بله</option>
                  <option value="false">خیر</option>
                </Select>
                <Select
                  name="vendorType"
                  placeholder="نوع غرفه "
                  label="نوع غرفه "
                >
                  <option value={undefined}>{"هیچکدام"}</option>
                  {utils?.VENDOR_TYPE_VALUES?.map((item) => {
                    return (
                      <option key={item.value} value={item.value}>
                        {item.name}
                      </option>
                    );
                  })}
                </Select>

                <div>
                  <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">مدرس دوره</label>
                  <div className="flex flex-wrap gap-2">
                    <button type="button" className="admin-field flex-1 text-right" onClick={() => userModalRef.current.showModal()}>{user || "انتخاب مدرس از فهرست کاربران"}</button>
                    {user && <button type="button" aria-label="حذف مدرس انتخاب‌شده" className="admin-form-cancel" onClick={deleteUser}><PiXFill /></button>}
                  </div>
                </div>
                <FormikDateOnlyInput name="freeShipingEndDate" label="پایان ارسال رایگان (تاریخ شمسی)" />
                <div className="">
                  <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                    عکس
                  </label>
                  <div className="admin-form-media">
                    <div className="flex gap-2">
                      {image ? (
                        <img
                          {...publicImageProps(image, { variant: "thumb_" })}
                          className="w-20 h-20 rounded-xl object-cover"
                          alt="تصویر اصلی دوره"
                        />
                      ) : (
                        <p className="text-sm">هنوز تصویری انتخاب نشده است</p>
                      )}
                      {/* <p className="max-w-12 overflow-hidden">{image || ""}</p> */}
                    </div>
                    <div className="flex gap-2">
                      {image && (
                        <Button
                          type="button"
                          onClick={() => setImage("")}
                          text={"حذف"}
                          color={"danger"}
                        />
                      )}

                      <Button
                        type="button"
                        onClick={() => imagesModal.current.showModal()}
                        text={image ? "ویرایش" : "انتخاب"}
                        color={"success"}
                      />
                    </div>
                  </div>
                </div>
              </div>

              </FormSection>
              <FormSection title="توضیحات و محتوا" description="توضیحات کوتاه برای معرفی سریع و متن کامل برای صفحه جزئیات استفاده می‌شود.">
              <div className="flex flex-col gap-3">
                <TextArea
                  name="shortDescription"
                  placeholder="توضیحات کوتاه"
                  label="توضیحات کوتاه"
                  type="text"
                />
              </div>
              <div className="mt-4">
                <Button
                  type="button"
                  onClick={() => copyImagesUrlModal.current.showModal()}
                  text={"انتخاب عکس توضیحات"}
                  color={"primary"}
                  className="mb-3"
                />
              </div>
              <div className="flex flex-col gap-y-2">
                <Editor defultData={location?.state?.description} onChange={setDescription} />
              </div>
              <label className="block mb-2 mt-2 text-sm font-medium text-gray-900 dark:text-white">
                این دوره مناسب چه کسانی هست ؟
              </label>
              <div className="flex flex-col gap-y-2">
                <Editor
                  defultData={location?.state?.targetAudience}
                  onChange={setTargetAudience}
                />
              </div>
              </FormSection>
              <FormSection title="محتوای آموزشی و پشتیبانی" description="سرفصل‌ها، پرسش‌ها، نتایج یادگیری و راه‌های پشتیبانی دوره را مدیریت کنید.">
              <div className="admin-form-tools">
                <button
                  onClick={() => sectionsRef.current.showModal()}
                  type="button"
                  className="text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                >
                  بخش های دوره
                </button>
                <button
                  onClick={() => questionRef.current.showModal()}
                  type="button"
                  className="text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                >
                  سوالات دوره
                </button>
                <button
                  onClick={() => learningRef.current.showModal()}
                  type="button"
                  className="text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                >
                  نتایج پس از اتمام دوره
                </button>
                <button
                  onClick={() => instructorRef.current.showModal()}
                  type="button"
                  className="text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                >
                  اطلاعاتی درباره مدرس
                </button>
                <button
                  onClick={() => featuresRef.current.showModal()}
                  type="button"
                  className="text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                >
                  ویژگی
                </button>
                <button
                  onClick={() => supportRef.current.showModal()}
                  type="button"
                  className="text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                >
                  پشتیبانی
                </button>
              </div>

              </FormSection>
              <div className="admin-form-actions">
                  <Button
                    text={location.state ? "ذخیره تغییرات" : "ایجاد دوره"}
                    loading={formik.isSubmitting}
                    color={"success"}
                    type="submit"
                  />
                  <button type="button" className="admin-form-cancel" onClick={() => navigate("/course-list")}>انصراف و بازگشت</button>
              </div>
            </Form>
          )}
        </Formik>

        <CourseSection
          ref={sectionsRef}
          handleSections={setSections}
          sectionsData={location?.state?.sections}
        />

        <CourseQuestions
          ref={questionRef}
          handleQuestions={setCourseQuestions}
          questionData={location?.state?.courseQuestions}
        />
        <LearningOutcomes
          ref={learningRef}
          handleLearning={setLearningOutcomes}
          learnData={location?.state?.learningOutcomes}
        />

        <InstructorInfo
          ref={instructorRef}
          handleInstructor={setInstructorInfo}
          instructorData={location?.state?.instructorInfo}
        />

        <CourseFeatures
          ref={featuresRef}
          handleFeatures={setCourseFeatures}
          featuresData={location?.state?.courseFeatures}
        />
        <SupportPlatforms
          ref={supportRef}
          handleSupport={setSupport}
          supportData={location?.state?.support}
        />

        <ImagesModal selectImg={false} ref={copyImagesUrlModal} />
        <UserModal ref={userModalRef} handleUser={handleUser} />
        <ImagesModal selectedImages={handleImages} ref={imagesModal} />
      </div>
    </AdminFormLayout>
  );
}
